import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert } from 'react-bootstrap';
import { reduxForm, Form } from 'redux-form';

import { GridLayout } from 'components/form/layout';
import { TextField, PasswordField, YesNoField } from 'components/form/field';
import validate from 'common/formValidation/lib';
import { buildBusinessPartnerValidation } from 'common/formValidation/settings/businessPartnerValidation';

const CreateNewBusinessPartner = ({ error, handleSubmit, hideForm, hiddenAll, showForm }) => {
    const [hidden, setHidden] = useState(true);

    const showNewForm = useCallback((e) => {
        e.preventDefault();
        setHidden(false);
        showForm();
    }, [setHidden]);
    const hideNewForm = useCallback((e) => {
        e.preventDefault();
        setHidden(true);
        hideForm();
    }, [setHidden]);

    return (
        <div className={classNames('new-simu', { hidden: hiddenAll })}>
            {hidden ? (
                <button onClick={showNewForm}>Nouveau partenaire</button>
            ) : (
                <button onClick={hideNewForm} className="cancel">Annuler</button>
            )}
            <div className={classNames('new-simulation-form', { hidden })}>
                <h1 className="text-center">Paramètres du nouveau partenaire</h1>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <GridLayout className="double condensed full-width">
                        <TextField
                            name="name"
                            title="Nom"
                            nombreCaractereMax={15}
                        />
                        <TextField
                            name="grantType"
                            title="Grant Type"
                        />
                        <TextField
                            name="clientId"
                            title="Client ID"
                        />
                        <TextField
                            name="urlSouscription"
                            title="URL de souscription"
                        />
                        <PasswordField
                            name="clientSecret"
                            title="Client secret"
                            autoComplete="new-password"
                        />
                        <TextField
                            name="urlToken"
                            title="URL token"
                        />
                        <YesNoField
                            name="hasManagementAct"
                            title="Acte de gestion"
                        />
                    </GridLayout>
                    <div className="submit">
                        <button type="submit">Créer</button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

CreateNewBusinessPartner.propTypes = {
    handleSubmit: PropTypes.func,
    hiddenAll: PropTypes.bool,
    showForm: PropTypes.func,
    hideForm: PropTypes.func,
    error: PropTypes.string,
};

export default reduxForm({
    form: 'simulation-businessPartner-create',
    initialValues: { hasManagementAct: false },
    onSubmitSuccess: (result, dispatch, { reset }) => {
        reset();
        document.location.reload();
    },
    validate: validate(buildBusinessPartnerValidation()),
})(CreateNewBusinessPartner);
